'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiHowItWorks = function (_React$Component) {
    _inherits(AiHowItWorks, _React$Component);

    function AiHowItWorks() {
        _classCallCheck(this, AiHowItWorks);

        return _possibleConstructorReturn(this, (AiHowItWorks.__proto__ || Object.getPrototypeOf(AiHowItWorks)).apply(this, arguments));
    }

    _createClass(AiHowItWorks, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M32,16c-8.822,0-16,7.179-16,16.001S23.178,48,32,48s16-7.177,16-15.999C48,23.178,40.822,16,32,16z M34.221,41.435h-4.856 v-4.301h4.856V41.435z M38.244,30.612c-0.416,0.694-1.11,1.388-2.359,2.359c-0.832,0.694-1.249,1.11-1.526,1.526 s-0.277,0.833-0.277,1.526h-4.579v-0.416c0-0.833,0.139-1.388,0.277-1.943c0.139-0.416,0.416-0.971,0.832-1.387 s1.11-1.11,2.359-2.081c0.694-0.555,0.971-0.971,0.971-1.388s-0.139-0.833-0.416-0.971c-0.277-0.139-0.694-0.416-1.249-0.416 s-0.971,0.139-1.387,0.555c-0.416,0.416-0.555,0.971-0.694,1.943l-4.579-0.555c0.139-1.665,0.832-3.053,1.804-4.163 c1.11-1.11,2.775-1.526,4.995-1.526c1.804,0,3.191,0.416,4.162,1.11c1.387,0.971,2.22,2.22,2.22,3.885 C38.799,29.363,38.522,30.057,38.244,30.612z' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-how-it-works', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-how-it-works', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiHowItWorks;
}(_react2.default.Component);

exports.default = AiHowItWorks;